import gql from 'graphql-tag';

export default gql`
  query IsLoggedIn {
    auth {
      isLoggedIn
    }
  }
`;
